export default defineNuxtPlugin(async () => {
  if (import.meta.client && !useRoute().path.startsWith('/manage')) {
    function urlBase64ToUint8Array(base64String: string) {
      const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        // eslint-disable-next-line no-useless-escape
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }
    async function requestNotificationPermission() {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        return true;
      }
      return false;
    }

    try {
      // Проверяем поддержку Service Worker
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.error('Push notifications не поддерживаются');
        return;
      }

      // Запрашиваем разрешение
      const hasPermission = await requestNotificationPermission();
      if (!hasPermission) {
        console.error('Разрешение на уведомления не получено');
        return;
      }

      // Регистрируем Service Worker
      const registration =
        await navigator.serviceWorker.register('/push-sw.js');
      // const registration =
      //   await navigator.serviceWorker.getRegistration('/dev-sw.js');

      const hasSub = await registration.pushManager.getSubscription();
      if (hasSub) {
        console.log('Уже есть подписка на push-уведомления');
        return;
      }

      // Подписываемся на push-уведомления
      const subscription = await registration?.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          'BC4N5Bqx8UxsvsnR4aqXH0Hqugnne2ViHkMEtc65pXvNIDIqIb2sjpQD1sjb9-eOZLJ1N7YTJAM-WR6SBUgEwi0',
        ),
      });

      // Отправляем подписку на сервер
      const response = await fetch('/api/v1/webpush/save_information', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status_type: 'subscribe',
          subscription: subscription?.toJSON(),
          browser: useRequestHeader('browser') ?? 'chrome',
          user_agent: useRequestHeader('user-agent'),
          group: 'anonymous',
        }),
      });

      if (response.ok) {
        console.log('Подписка на push-уведомления успешно сохранена');
      } else {
        console.error('Ошибка при сохранении подписки');
      }
    } catch (error) {
      console.error('Ошибка при подписке на push-уведомления:', error);
    }
  }
});
